mutation DeleteProvisionalPledge($pledgeId: ID!) {
  deleteProvisionalPledge(input: { pledgeId: $pledgeId }) {
    success
  }
}
